module.exports = __webpack_public_path__ + "img/default-image.e98b0d47.jpg";